import {ProductTypeEnum} from "../enums";
import {ProductResponseDTO} from "../DTO";

enum Gender { M = 'm', F = 'f' }

const nounByProductType: Record<ProductTypeEnum, { g: Gender; lemma: string; plural: string }> = {
  [ProductTypeEnum.OBIETTIVO]:  { g: Gender.M, lemma: 'obiettivo', plural: 'obiettivi' },
  [ProductTypeEnum.MIRRORLESS]: { g: Gender.F, lemma: 'fotocamera', plural: 'fotocamere' },
  [ProductTypeEnum.COMPATTA]: { g: Gender.F, lemma: 'fotocamera', plural: 'fotocamere' },
  [ProductTypeEnum.REFLEX]: { g: Gender.F, lemma: 'fotocamera', plural: 'fotocamere' },
  [ProductTypeEnum.BRIDGE]: { g: Gender.F, lemma: 'fotocamera', plural: 'fotocamere' },
};

// --- Articoli determinativi (forma semplice: niente "l'") ---
const artDef = (g: Gender) => (g === Gender.M ? 'il' : 'la');

// --- Dimostrativi ---
const demonstrativeThis = (g: Gender) => (g === Gender.M ? 'questo' : 'questa');

const adjective = (g: Gender, masculine: string, feminine: string) =>
  g === Gender.M ? masculine : feminine;

// --- Preposizioni articolate singolari (forma semplice) ---
const prep = (g: Gender) => ({
  su: g === Gender.M ? 'sul'   : 'sulla',
  di: g === Gender.M ? 'del'   : 'della',
  a:  g === Gender.M ? 'al'    : 'alla',
  da: g === Gender.M ? 'dal'   : 'dalla',
  in: g === Gender.M ? 'nel'   : 'nella',
});

// Helper principale: ritorna tutto ciò che serve dato un prodotto
export function grammarFor(product: ProductResponseDTO) {
  const meta = nounByProductType[product.productData.productType];
  const g = meta.g;
  return {
    gender: g,
    lemma: meta.lemma,
    plural: meta.plural,
    art: artDef(g),
    demoThis: demonstrativeThis(g),
    adjective: (masculine: string, feminine: string) => adjective(g, masculine, feminine),
    prep: prep(g),
  };
}
